import { Monitor, Moon, Sun } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Theme, useTheme } from "@/components/theme-provider";

const ORDER: Theme[] = ["light", "dark", "system"];

const LABELS: Record<Theme, string> = {
  light: "Light",
  dark: "Dark",
  system: "System",
};

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  const cycle = () => setTheme(ORDER[(ORDER.indexOf(theme) + 1) % ORDER.length]);

  const iconClass = (active: boolean) =>
    `absolute inset-0 m-auto size-3.5 transition-all duration-300 ${
      active
        ? "scale-100 rotate-0 opacity-100"
        : "scale-50 -rotate-90 opacity-0"
    }`;

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon-sm"
      onClick={cycle}
      aria-label={`Theme: ${LABELS[theme]}. Click to switch.`}
      title={`Theme: ${LABELS[theme]}`}
      className="relative overflow-hidden"
    >
      <Sun className={iconClass(theme === "light")} />
      <Moon className={iconClass(theme === "dark")} />
      <Monitor className={iconClass(theme === "system")} />
    </Button>
  );
}
